import validate from "/opt/development/izi_bi/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/development/izi_bi/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "auth-or-token": () => import("/opt/development/izi_bi/middleware/auth-or-token.ts"),
  auth: () => import("/opt/development/izi_bi/middleware/auth.ts"),
  guest: () => import("/opt/development/izi_bi/middleware/guest.ts"),
  permission: () => import("/opt/development/izi_bi/middleware/permission.ts")
}